// extracted by mini-css-extract-plugin
module.exports = {"root":"DateTime_root__21bcl","label":"DateTime_label__1bHcb"};